import I18n from '../../config/locales';

export const USER_LIST_REQUEST = 'USER_LIST_REQUEST';
export const USER_LIST_SUCCESS = 'USER_LIST_SUCCESS';
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const USER_REQUEST_FAILURE = 'USER_REQUEST_FAILURE';
export const FIELD_REQUIRED = I18n.t('users.fieldRequired');
export const VALID_EMAIL = I18n.t('users.validEmail');
export const EMAIL_MATCH = I18n.t('users.emailMatch');
export const VALID_PHONE = I18n.t('company.validPhone');
export const LENGTH_PHONE = I18n.t('users.errorMessageLengthPhone');
